import type { CSSProperties } from 'react';

export type RawColorPurpose =
  | 'map-data'
  | 'visualization'
  | 'media'
  | 'external-identity'
  | 'provider-attribution'
  | 'other:academic-identity';

export type RawColorSlot = 'accent' | 'fill' | 'stroke' | 'marker';
export type RawColorException = `${RawColorPurpose}:${RawColorSlot}`;
export type RawColorVariable = `--ss-raw-color-${RawColorSlot}`;

const PURPOSES: ReadonlySet<string> = new Set([
  'map-data',
  'visualization',
  'media',
  'external-identity',
  'provider-attribution',
  'other:academic-identity',
]);
const SLOTS: ReadonlySet<string> = new Set(['accent', 'fill', 'stroke', 'marker']);

export function rawColorUsage(input: {
  purpose: RawColorPurpose;
  slot: RawColorSlot;
  value: string;
}): {
  'data-ss-color-exception': RawColorException;
  style: CSSProperties & Partial<Record<RawColorVariable, string>>;
} {
  if (!PURPOSES.has(input.purpose) || !SLOTS.has(input.slot) || !input.value.trim()) {
    throw new Error('Invalid Scarlet Sync raw-color exception');
  }
  const variable = `--ss-raw-color-${input.slot}` as RawColorVariable;
  return {
    'data-ss-color-exception': `${input.purpose}:${input.slot}`,
    style: { [variable]: input.value },
  };
}
